// extracted by mini-css-extract-plugin
module.exports = {"InputContainer":"SearchInput_InputContainer__2-Lch","Input":"SearchInput_Input__2-c6t","Button":"SearchInput_Button__3ynkF"};